<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="forced-review-dialog"
    center
  >
    <!-- 开始页面 -->
    <div v-if="currentPhase === 'start'" class="start-phase">
      <div class="phase-header">
        <h2>单词复习</h2>
        <el-button type="text" icon="el-icon-close" @click="closeDialog" class="close-btn"></el-button>
      </div>

      <div class="start-content">
        <div class="review-category">
          <i class="el-icon-star-on"></i>
          <h3>复习词汇</h3>
          <p>巩固已学单词，提升记忆效果</p>
      </div>

        <div class="word-stats">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ localReviewWords.length }}</div>
              <div class="stat-label">需要复习</div>
            </div>
          </div>
          
          <div class="stat-card urgent">
            <div class="stat-icon">
              <i class="el-icon-warning"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ localReviewWords.length }}</div>
              <div class="stat-label">今日单词</div>
            </div>
          </div>
        </div>

        <div class="start-actions">
          <el-button type="primary" size="large" @click="startReview" class="start-button">
            <i class="el-icon-play"></i>
            开始复习
          </el-button>
        </div>

      </div>
    </div>

    <!-- 第一部分：看词想义 -->
    <div v-if="currentPhase === 'review'" class="review-phase">
      <div class="phase-header">
        <h2>单词复习中...</h2>
        <el-button type="text" icon="el-icon-close" @click="closeDialog" class="close-btn"></el-button>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: reviewProgress + '%' }"></div>
        </div>
      </div>

      <div class="word-display">
        <div class="word-card">
          <div class="word-content">
            <!-- 单词图片 -->
            <div class="word-image" v-if="currentWord && (currentWord._resolved_image_url || currentWord.image_url)">
              <img 
                :src="currentWord._resolved_image_url || getImageUrl(currentWord.image_url)" 
                :alt="currentWord.english_word"
                class="word-img"
                @error="handleImageError"
                @load="handleImageLoad"
              />
            </div>
            
            <div class="word-text">
              <h1 class="english-word">{{ currentWord.english_word }}</h1>
              <div class="phonetic-info">
                <span class="phonetic">英[{{ currentWord.phonetic_en }}]</span>
                <span class="phonetic">美[{{ currentWord.phonetic_us }}]</span>
                <el-button type="primary" size="small" icon="el-icon-microphone" @click="playPronunciation"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="meaning-area" v-if="showMeaning">
          <div class="meaning-card">
            <h3>{{ currentWord.chinese_meaning }}</h3>
            <p v-if="currentWord.example_sentence" class="example">{{ currentWord.example_sentence }}</p>
          </div>
        </div>

        <div class="question-area" v-else>
          <div class="question-mark">?</div>
          <p>请回忆这个单词的中文含义</p>
        </div>

      <div class="action-buttons">
        <el-button type="success" @click="handleRemember" :disabled="showMeaning || isShowingMeaningDelay">
          <i class="el-icon-check"></i>
          我记得
        </el-button>
        <el-button type="warning" @click="handleForget" :disabled="showMeaning || isShowingMeaningDelay">
          <i class="el-icon-close"></i>
          不记得
        </el-button>
        <el-button type="info" @click="handleSkip" :disabled="showMeaning || isShowingMeaningDelay">
          <i class="el-icon-arrow-right"></i>
          跳过
        </el-button>
        <el-button type="primary" @click="showMeaning = true" v-if="!showMeaning && !isShowingMeaningDelay">
          <i class="el-icon-view"></i>
          显示词义
        </el-button>
        <el-button type="primary" @click="nextWord" v-if="showMeaning && !isShowingMeaningDelay">
          <i class="el-icon-arrow-right"></i>
          下一个
        </el-button>
        <div v-if="isShowingMeaningDelay" class="delay-indicator">
          <i class="el-icon-loading"></i>
          正在显示词义...
        </div>
      </div>
    </div>

    <!-- 第二部分：拼写测试选择 -->
    <div v-if="currentPhase === 'test-mode'" class="test-mode-selection">
      <div class="phase-header">
        <h2>拼写测试</h2>
        <p>请选择测试模式</p>
      </div>

          <div class="mode-buttons">
        <el-button type="primary" size="large" @click="startSpellingTest('ordered')">
          <i class="el-icon-sort"></i>
          顺序测试
        </el-button>
        <el-button type="success" size="large" @click="startSpellingTest('random')">
          <i class="el-icon-refresh"></i>
          乱序测试
        </el-button>
      </div>
    </div>

    <!-- 拼写测试 -->
    <div v-if="currentPhase === 'spelling'" class="spelling-phase">
      <div class="phase-header">
        <h2>拼写测试 - {{ testMode === 'ordered' ? '顺序' : '乱序' }}</h2>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: spellingProgress + '%' }"></div>
          </div>
        </div>

        <div class="spelling-interface">
        <div class="word-info">
          <h3>{{ currentWord.chinese_meaning }}</h3>
          <el-button type="primary" size="small" @click="playPronunciation">
            <i class="el-icon-microphone"></i>
            播放发音
          </el-button>
        </div>

        <div class="input-area">
          <div class="timer-display" v-if="!showAnswer">
            <span class="timer-text">剩余时间: {{ timeLeft }}秒</span>
            <div class="timer-bar">
              <div class="timer-fill" :style="{ width: (timeLeft / 10) * 100 + '%' }"></div>
            </div>
            </div>
            <input
              ref="spellingInput"
              v-model="userInput"
              @keyup.enter="checkSpelling"
              @paste.prevent
              @copy.prevent
              @cut.prevent
              type="text"
              placeholder="请输入英文单词..."
              class="spelling-input"
              :class="{ correct: showAnswer && isCorrect, incorrect: showAnswer && !isCorrect }"
              :disabled="showAnswer"
            />
            <el-button type="primary" @click="checkSpelling" :disabled="!userInput.trim() || showAnswer">
              提交
            </el-button>
          </div>

        <div v-if="showAnswer" class="answer-display" :class="{ correct: isCorrect, incorrect: !isCorrect }">
          <div class="correct-word">{{ currentWord.english_word }}</div>
          <div class="answer-feedback">
            {{ isCorrect ? '正确！' : '错误，正确答案是：' }}
        </div>
          </div>
        </div>

      <!-- 拼写测试阶段不需要手动下一个按钮，3秒后自动切换 -->
    </div>

    <!-- 强制拼写 -->
    <div v-if="currentPhase === 'forced-spelling'" class="forced-spelling-phase">
      <div class="phase-header">
        <h2>强制拼写</h2>
        <p>请按顺序输入字母，只能输入正确的字母</p>
      </div>

      <div class="forced-spelling-interface">
        <div class="word-display">
          <h3>{{ currentWord.chinese_meaning }}</h3>
          <div class="progress-display">
            进度: {{ forcedSpellingIndex }}/{{ currentWord.english_word.length }}
          </div>
        </div>

        <div class="input-area">
          <input
            v-model="userInput"
            @keydown="handleForcedSpellingInput"
            type="text"
            placeholder="请按顺序输入字母..."
            class="forced-spelling-input"
            :disabled="forcedSpellingIndex >= currentWord.english_word.length"
          />
          <div class="expected-char" v-if="forcedSpellingIndex < currentWord.english_word.length">
            下一个字母: {{ currentWord.english_word[forcedSpellingIndex].toUpperCase() }}
            <br>
            <small style="color: #999;">
              调试: 单词={{ currentWord.english_word }}, 索引={{ forcedSpellingIndex }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- 学习小结 -->
    <div v-if="currentPhase === 'summary'" class="summary-phase">
      <div class="phase-header">
        <h2>学习小结</h2>
        </div>

      <div class="summary-content">
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-label">记忆夹生词 (个):</span>
            <span class="stat-value">{{ summaryStats.memorizedWords }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">拼写夹生词 (个):</span>
            <span class="stat-value">{{ summaryStats.spelledWords }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">连续识别错误 (个):</span>
            <span class="stat-value" :class="{ error: summaryStats.consecutiveErrors > 0 }">
              {{ summaryStats.consecutiveErrors }}
            </span>
          </div>
          <div class="stat-item">
            <span class="stat-label">连续拼写错误 (个):</span>
            <span class="stat-value" :class="{ error: summaryStats.consecutiveSpellingErrors > 0 }">
              {{ summaryStats.consecutiveSpellingErrors }}
            </span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总复习时间:</span>
            <span class="stat-value">{{ Math.floor(summaryStats.totalReviewTime / 60) }}分{{ summaryStats.totalReviewTime % 60 }}秒</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">学习准确率:</span>
            <span class="stat-value" :class="{ success: summaryStats.accuracy >= 80 }">
              {{ summaryStats.accuracy }}%
            </span>
          </div>
          <div class="stat-item">
            <span class="stat-label">获得金币:</span>
            <span class="stat-value coins">{{ summaryStats.earnedCoins }}</span>
          </div>
        </div>

        <div class="reward-section">
          <div class="reward-text">
            本次学习/复习将收获 {{ summaryStats.earnedCoins }}
            <i class="el-icon-coin"></i>
      </div>
    </div>

        <div class="action-buttons">
          <el-button type="success" size="large" @click="completeReview">
            <i class="el-icon-check"></i>
            保存退出
          </el-button>
      </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import { homeApi } from "@/api/home";

export default {
  name: "ForcedReviewDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    reviewWords: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.value,
      
      // 复习阶段控制
      currentPhase: 'start', // start, review, test-mode, spelling, forced-spelling, summary
      
      // 单词相关
      currentWordIndex: 0,
      currentWord: {},
      showMeaning: false,
      
      // 本地单词列表（避免直接修改prop）
      localReviewWords: [],
      
      // 复习相关
      reviewProgress: 0,
      forgetCount: 0,
      wrongWords: [],
      
      // 拼写测试相关
      testMode: 'ordered', // ordered, random
      spellingProgress: 0,
      userInput: '',
      showAnswer: false,
      isCorrect: false,
      spellingTimer: null,
      timeLeft: 10,
      
      // 强制拼写相关
      forcedSpellingIndex: 0,
      
      // 统计相关
      newWordCount: 0,
      recognitionCount: 0,
      startTime: null, // 初始化为null，等用户真正开始学习时再设置
      
      // 学习小结
      summaryStats: {
        memorizedWords: 0,
        spelledWords: 0,
        consecutiveErrors: 0,
        consecutiveSpellingErrors: 0,
        earnedCoins: 0
      },
      
      // 延迟状态
      isShowingMeaningDelay: false,
      meaningDelayTimer: null
    };
  },
  computed: {
    // 当前生词数（新学的单词）
    currentNewWords() {
      return this.newWordCount;
    },
    
    // 识别总次数（包括复习和拼写）
    totalRecognitionCount() {
      return this.recognitionCount;
    }
    
    // 金币计算统一在 calculateSummaryStats 中进行：uniqueWordsLearned * 3
  },
  watch: {
    value(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.initReview();
      } else {
        // 弹窗关闭时停止背景音乐
        try {
          const backgroundMusicManager = require('@/utils/backgroundMusicManager').default;
          backgroundMusicManager.stopForcedReviewMusic();
          console.log('🎵 弹窗关闭，背景音乐已停止');
        } catch (error) {
          console.error('🎵 停止背景音乐失败:', error);
        }
      }
    }
  },
  methods: {
    // 关闭对话框
    closeDialog() {
      this.$confirm('确定要关闭复习吗？当前复习进度将不会保存。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 停止背景音乐
        try {
          const backgroundMusicManager = require('@/utils/backgroundMusicManager').default;
          backgroundMusicManager.stopForcedReviewMusic();
        } catch (error) {
          console.error('停止背景音乐失败:', error);
        }
        
        // 关闭对话框
        this.dialogVisible = false;
        this.$emit('close');
      }).catch(() => {
        // 用户取消关闭
      });
    },

    initReview() {
      // 复制prop到本地数组，避免直接修改prop
      this.localReviewWords = [...this.reviewWords];
      this.currentPhase = 'start';
      this.currentWordIndex = 0;
      this.currentWord = this.localReviewWords[0] || {};
      this.showMeaning = false;
      this.reviewProgress = 0;
      this.forgetCount = 0;
      this.wrongWords = [];
      // 不在这里设置startTime，等用户真正开始学习时再设置
      this.newWordCount = 0;
      this.recognitionCount = 0;
    },

    // 处理图片加载错误
    handleImageError(event) {
      console.warn('图片加载失败:', event.target.src);
      event.target.style.display = 'none';
    },

    // 处理图片加载成功
    handleImageLoad(event) {
      console.log('图片加载成功:', event.target.src);
    },

    // 开始复习
    async startReview() {
      this.currentPhase = 'review';
      // 只在第一次开始学习时设置时间
      if (!this.startTime) {
        this.startTime = Date.now();
      }
      
      // 启动背景音乐
      try {
        const backgroundMusicManager = require('@/utils/backgroundMusicManager').default;
        await backgroundMusicManager.startForcedReviewMusic();
      } catch (error) {
        console.error('🎵 启动背景音乐失败:', error);
      }

      this.autoPlayWordTwice();
    },

    // 第一部分：看词想义
    handleRemember() {
      this.recognitionCount++;
      // 记住的单词记录到已学集合（不重复计数）
      const wordId = this.currentWord.id || this.currentWord.word_id;
      if (wordId && !this.localReviewWords.slice(0, this.currentWordIndex).find(w => (w.id || w.word_id) === wordId)) {
        this.newWordCount++; // 只在首次记住时计数
      }
      this.reviewProgress = ((this.currentWordIndex + 1) / this.localReviewWords.length) * 100;
      
      // 显示中文意思几秒钟
      this.isShowingMeaningDelay = true;
      this.showMeaning = true;
      
      // 清除之前的定时器
      if (this.meaningDelayTimer) {
        clearTimeout(this.meaningDelayTimer);
      }
      
      // 1秒后自动进入下一个单词
      this.meaningDelayTimer = setTimeout(() => {
        this.isShowingMeaningDelay = false;
        this.nextWord();
      }, 1000);
    },

    handleForget() {
      this.forgetCount++;
      this.showMeaning = true;
      
      // 每次点击"不记得"都将当前单词重新加入队列末尾
      const currentWord = this.localReviewWords[this.currentWordIndex];
      this.localReviewWords.push({...currentWord, isRetry: true});
      
      // 1秒后自动切换到下一个单词
      setTimeout(() => {
        this.nextWord();
      }, 1000);
    },

    handleSkip() {
      this.recognitionCount++;
      // 跳过的单词也记录（但不重复计数）
      const wordId = this.currentWord.id || this.currentWord.word_id;
      if (wordId && !this.localReviewWords.slice(0, this.currentWordIndex).find(w => (w.id || w.word_id) === wordId)) {
        this.newWordCount++;
      }
      this.reviewProgress = ((this.currentWordIndex + 1) / this.localReviewWords.length) * 100;
      this.nextWord();
    },
    
    nextWord() {
      // 如果是强制拼写阶段，不应该调用nextWord
      if (this.currentPhase === 'forced-spelling') {
        console.warn('强制拼写阶段不应调用nextWord');
        return;
      }
      
      this.currentWordIndex++;
      this.showMeaning = false;
      this.forgetCount = 0;
      this.isShowingMeaningDelay = false;
      
      // 清除延迟定时器
      if (this.meaningDelayTimer) {
        clearTimeout(this.meaningDelayTimer);
        this.meaningDelayTimer = null;
      }
      
      // 重置测验阶段状态（只处理正常拼写，不处理强制拼写）
      if (this.currentPhase === 'spelling') {
        this.userInput = '';
        this.showAnswer = false;
        this.isCorrect = false;
        this.timeLeft = 10;
        this.forcedSpellingIndex = 0; // 重置强制拼写索引
        this.stopSpellingTimer();
        this.startSpellingTimer();
      }
      
      if (this.currentWordIndex >= this.localReviewWords.length) {
        // 复习完成，进入测试模式
          this.currentPhase = 'test-mode';
          return;
        }
        
      this.currentWord = this.localReviewWords[this.currentWordIndex];
      this.autoPlayWordTwice();
    },

    // 第二部分：拼写测试
    startSpellingTest(mode) {
      this.testMode = mode;
      this.currentPhase = 'spelling';
      this.currentWordIndex = 0;
      this.currentWord = this.localReviewWords[0] || {};
      this.userInput = '';
      this.showAnswer = false;
      this.spellingProgress = 0;
      
      // 如果还没有开始时间，现在开始计时
      if (!this.startTime) {
        this.startTime = Date.now();
      }
      
      if (mode === 'random') {
        // 乱序测试，打乱单词顺序
        this.localReviewWords = this.shuffleArray([...this.localReviewWords]);
        this.currentWord = this.localReviewWords[0] || {};
      }
      
      // 开始10秒倒计时
      this.startSpellingTimer();
      
      // 等待DOM更新后自动聚焦输入框
      this.$nextTick(() => {
        if (this.$refs.spellingInput) {
          this.$refs.spellingInput.focus();
        }
      });
    },

    startSpellingTimer() {
      this.timeLeft = 20;
      this.spellingTimer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          // 时间到，自动判断为错误
          this.handleTimeUp();
        }
      }, 1000);
    },

    stopSpellingTimer() {
      if (this.spellingTimer) {
        clearInterval(this.spellingTimer);
        this.spellingTimer = null;
      }
    },

    handleTimeUp() {
      this.stopSpellingTimer();
      this.isCorrect = false;
      this.showAnswer = true;
      this.recognitionCount++; // 时间到也算作识别
      this.addToWrongWords();
      
      // 时间到也算作拼写错误，添加到错词列表末尾，稍后重复测试
      this.localReviewWords.push({...this.currentWord, isRetry: true});
      
      // 只有在正常拼写阶段才自动切换下一个单词
      if (this.currentPhase === 'spelling') {
        // 3秒后自动切换下一个单词
        setTimeout(() => {
          this.nextWord();
        }, 3000);
      }
      // 强制拼写阶段不自动切换，让用户继续输入
    },
    
    checkSpelling() {
      this.stopSpellingTimer();
      const userWord = this.userInput.toLowerCase().trim();
      const correctWord = this.currentWord.english_word.toLowerCase();
      this.isCorrect = userWord === correctWord;
      this.showAnswer = true;
      
      // 拼写测试也算作识别
      this.recognitionCount++;
      
      if (this.isCorrect) {
        // 拼写正确，记录到已学单词（不重复计数）
        const wordId = this.currentWord.id || this.currentWord.word_id;
        if (wordId && !this.localReviewWords.slice(0, this.currentWordIndex).find(w => (w.id || w.word_id) === wordId)) {
          this.newWordCount++;
        }
        this.spellingProgress = ((this.currentWordIndex + 1) / this.localReviewWords.length) * 100;
      } else {
        const needForcedSpelling = this.addToWrongWords();
        if (needForcedSpelling) {
          // 需要立即进入强制拼写，不再继续自动切换
          return;
        }
        // 拼写错误，添加到错词列表末尾，稍后重复测试
        this.localReviewWords.push({...this.currentWord, isRetry: true});
      }
      
      // 3秒后自动切换下一个单词
      setTimeout(() => {
        this.nextSpellingWord();
      }, 3000);
    },

    addToWrongWords() {
      // 拼写错误，加入错词列表
      const wrongWord = this.wrongWords.find(w => w.english_word === this.currentWord.english_word);
      if (wrongWord) {
        wrongWord.errorCount++;
        if (wrongWord.errorCount >= 3) {
          // 连续错误3次，标记需要强制拼写
          wrongWord.needForcedSpelling = true;
          // 立即开始强制拼写
          this.startForcedSpelling([wrongWord]);
          return true; // 返回true表示已进入强制拼写
        }
      } else {
        this.wrongWords.push({
          ...this.currentWord,
          errorCount: 1,
          needForcedSpelling: false
        });
      }
      return false; // 返回false表示继续正常流程
    },
    
    nextSpellingWord() {
      this.currentWordIndex++;
      this.userInput = '';
      this.showAnswer = false;
      // 不在这里更新进度条，只有答对才更新
      
      if (this.currentWordIndex >= this.localReviewWords.length) {
        // 拼写测试完成，检查是否有需要强制拼写的词
        const forcedSpellingWords = this.wrongWords.filter(w => w.needForcedSpelling);
        if (forcedSpellingWords.length > 0) {
          this.startForcedSpelling(forcedSpellingWords);
        } else if (this.wrongWords.length > 0) {
          // 有错词，继续循环复习直到全对
          this.startWrongWordsReview();
        } else {
          // 所有词都正确，完成复习
          this.showSummary();
        }
        return;
      }

      this.currentWord = this.localReviewWords[this.currentWordIndex];
      // 开始新的10秒倒计时
      this.startSpellingTimer();
      
      // 等待DOM更新后自动聚焦输入框
      this.$nextTick(() => {
        if (this.$refs.spellingInput) {
          this.$refs.spellingInput.focus();
        }
      });
    },
    
    // 错词重复测试
    startWrongWordsReview() {
      // 将错词添加到测试列表末尾，继续循环复习
      const originalLength = this.localReviewWords.length;
      this.localReviewWords = [...this.localReviewWords, ...this.wrongWords];
      this.wrongWords = []; // 清空错词列表，重新开始统计
      this.currentWordIndex = originalLength; // 从错词开始
      this.currentWord = this.localReviewWords[this.currentWordIndex];
      this.startSpellingTimer();
      
      // 等待DOM更新后自动聚焦输入框
      this.$nextTick(() => {
        if (this.$refs.spellingInput) {
          this.$refs.spellingInput.focus();
        }
      });
    },

    // 强制拼写
    startForcedSpelling(forcedWords) {
      this.currentPhase = 'forced-spelling';
      this.currentWordIndex = 0;
      this.wrongWords = forcedWords; // 只处理需要强制拼写的词
      this.currentWord = this.wrongWords[0] || {};
      
      // 完全重置所有拼写相关状态
      this.userInput = '';
      this.showAnswer = false;
      this.isCorrect = false;
      this.timeLeft = 10;
      this.forcedSpellingIndex = 0;
      
      // 清除所有定时器
      if (this.spellingTimer) {
        clearInterval(this.spellingTimer);
        this.spellingTimer = null;
      }
      if (this.meaningDelayTimer) {
        clearTimeout(this.meaningDelayTimer);
        this.meaningDelayTimer = null;
      }
    },
    
    handleForcedSpellingInput(event) {
      // 只处理单个字母按键，不阻止其他功能键（兼容输入法）
      if (event.key.length === 1 && /[a-zA-Z]/.test(event.key)) {
        event.preventDefault();
        
        const inputChar = event.key.toLowerCase();
        const expectedChar = this.currentWord.english_word[this.forcedSpellingIndex].toLowerCase();
        
        if (inputChar === expectedChar) {
          // 添加原始大小写的字母到显示
          this.userInput += this.currentWord.english_word[this.forcedSpellingIndex];
          this.forcedSpellingIndex++;
          
          if (this.forcedSpellingIndex >= this.currentWord.english_word.length) {
            // 强制拼写完成
            this.completeForcedSpelling();
          }
        } else {
          this.$message.warning(`请输入字母: ${expectedChar.toUpperCase()}`);
        }
      }
      // 允许Backspace、Delete、方向键等功能键正常工作
    },
    
    completeForcedSpelling() {
      // 从错词列表中移除当前单词
      const currentWordIndex = this.wrongWords.findIndex(w => w.english_word === this.currentWord.english_word);
      if (currentWordIndex !== -1) {
        const completedWord = this.wrongWords.splice(currentWordIndex, 1)[0];
        
        // 强制拼写完成算作学习（不重复计数）
        const wordId = completedWord.id || completedWord.word_id;
        if (wordId && !this.localReviewWords.find(w => (w.id || w.word_id) === wordId && w.forcedSpellingCompleted)) {
          this.newWordCount++;
          this.recognitionCount++;
        }
        
        // 标记为已完成强制拼写，避免重复添加
        completedWord.forcedSpellingCompleted = true;
        completedWord.errorCount = 0; // 重置错误计数
      }
      
      if (this.wrongWords.length > 0) {
        // 还有错词，继续强制拼写
        this.currentWord = this.wrongWords[0] || {};
        this.userInput = '';
        this.forcedSpellingIndex = 0;
      } else {
        // 所有错词都完成强制拼写，直接进入小结
        this.showSummary();
      }
    },

    // 显示学习小结
    showSummary() {
      this.currentPhase = 'summary';
      this.calculateSummaryStats();
    },

    calculateSummaryStats() {
      // 计算实际学习的唯一单词数量
      const uniqueWordsLearned = new Set(this.localReviewWords.map(word => word.id || word.word_id)).size;
      
      this.summaryStats = {
        memorizedWords: this.newWordCount, // 记住的单词数
        spelledWords: this.recognitionCount, // 拼写测试的单词数
        consecutiveErrors: this.forgetCount, // 连续识别错误数
        consecutiveSpellingErrors: this.wrongWords.length, // 连续拼写错误数
        totalReviewTime: this.startTime ? Math.floor((Date.now() - this.startTime) / 1000) : 0, // 总复习时间(秒)
        accuracy: this.localReviewWords.length > 0 ? 
          Math.round(((this.localReviewWords.length - this.wrongWords.length) / this.localReviewWords.length) * 100) : 100,
        earnedCoins: Math.max(1, Math.floor(uniqueWordsLearned * 3)) // 按实际学习的唯一单词数量计算金币
      };
    },

    // 完成复习
    async completeReview() {
      try {
        // 停止背景音乐
        try {
          const backgroundMusicManager = require('@/utils/backgroundMusicManager').default;
          backgroundMusicManager.stopForcedReviewMusic();
        } catch (error) {
          console.error('🎵 停止背景音乐失败:', error);
        }
        
        // 计算实际学习的唯一单词数量
        const uniqueWordsLearned = new Set(this.localReviewWords.map(word => word.id || word.word_id)).size;
        const studyTimeSeconds = this.startTime ? Math.floor((Date.now() - this.startTime) / 1000) : 0;
        
        // 提交学习数据
        const learningData = {
          words: this.localReviewWords.map(word => ({
            word_id: word.id || word.word_id,
            english_word: word.english_word,
            chinese_meaning: word.chinese_meaning,
            is_correct: !this.wrongWords.find(w => w.english_word === word.english_word),
            is_spelling_correct: !this.wrongWords.find(w => w.english_word === word.english_word),
            review_type: 'review'
          })),
          total_words: uniqueWordsLearned,
          correct_words: uniqueWordsLearned - this.wrongWords.length,
          wrong_words: this.wrongWords.length,
          study_time: studyTimeSeconds,
          study_date: new Date().toISOString().split('T')[0],
          earned_coins: this.summaryStats.earnedCoins,
          reviewed_count: uniqueWordsLearned,
          new_words_count: uniqueWordsLearned,
          accuracy: this.summaryStats.accuracy
        };
        
        await homeApi.submitLearning(learningData);
        
        this.$message.success(`学习数据已保存！获得 ${this.summaryStats.earnedCoins} 金币！`);
        
        // 刷新首页数据
        this.$emit('review-completed');
        
      } catch (err) {
        console.error("提交学习数据失败：", err);
        this.$message.error("保存学习数据失败: " + (err.message || err));
      }
      this.dialogVisible = false;
    },

    // 获取图片完整URL
    getImageUrl(imageUrl) {
      if (!imageUrl) {
        return '';
      }
      
      // 如果已经是完整URL，直接返回
      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
      }
      
      // 拼接API基础URL和图片路径
      const { config } = require('@/config/env');
      return config.VOICE_URL + imageUrl;
    },

    // 工具方法
    playPronunciation() {
      // 播放单词发音
      const pronunciationUrl = this.currentWord.pronunciation_url;
      if (pronunciationUrl) {
        // 使用音频工具函数
        const { playAudio } = require('@/utils/audioUtils');
        playAudio(pronunciationUrl).catch(e => {
          console.error("播放音频失败:", e);
          this.$message.warning("音频播放失败");
        });
      } else {
        this.$message.info("暂无发音文件");
      }
    },

     // 自动播放两次发音（带间隔）
    autoPlayWordTwice() {
      const pronunciationUrl = this.currentWord && this.currentWord.pronunciation_url;
      if (!pronunciationUrl) {
        return;
      }
      const { playAudio } = require('@/utils/audioUtils');
      // 第一次播放
      playAudio(pronunciationUrl)
        .then(() => {
          // 设定一个轻微延迟再播第二次，避免音频尚未释放
          setTimeout(() => {
            playAudio(pronunciationUrl).catch(err => {
              console.warn('[AutoPlay] 第二次播放失败', err);
            });
          }, 1000); // 可调节间隔
        })
        .catch(err => {
          console.warn('[AutoPlay] 第一次播放失败', err);
        });
    },

    
    shuffleArray(array) {
      const newArray = [...array];
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
      }
      return newArray;
    }
  },
  
  beforeDestroy() {
    // 清理拼写定时器
    this.stopSpellingTimer();
    
    // 清理延迟显示词义定时器
    if (this.meaningDelayTimer) {
      clearTimeout(this.meaningDelayTimer);
      this.meaningDelayTimer = null;
    }
    
    // 停止背景音乐
    try {
      const backgroundMusicManager = require('@/utils/backgroundMusicManager').default;
      backgroundMusicManager.stopForcedReviewMusic();
      console.log('🎵 组件销毁，背景音乐已停止');
    } catch (error) {
      console.error('🎵 停止背景音乐失败:', error);
    }
  }
};
</script>

<style scoped>
.forced-review-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  width: 800px !important;
  height: 600px !important;
  max-width: 800px !important;
  max-height: 600px !important;
}
.el-dialog {
  max-width: 800px !important;
}

.forced-review-dialog .el-dialog__body {
  height: 500px !important;
  overflow-y: auto;
}

/* 开始页面样式 */
.start-phase {
  text-align: center;
}

.start-content {
  padding: 50px 40px;
}

.review-category {
  margin-bottom: 40px;
}

.review-category i {
  font-size: 48px;
  color: #ffd700;
  margin-bottom: 15px;
  display: block;
}

.review-category h3 {
  font-size: 28px;
  color: #2c3e50;
  margin: 0 0 10px 0;
}

.review-category p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.word-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 50px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 25px 35px;
  background: #f8f9fa;
  border-radius: 16px;
  min-width: 180px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.stat-card.urgent {
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  color: white;
}

.stat-icon {
  margin-right: 15px;
}

.stat-icon i {
  font-size: 36px;
  color: #409eff;
}

.stat-card.urgent .stat-icon i {
  color: white;
}

.stat-info {
  text-align: left;
}

.stat-number {
  font-size: 36px;
  font-weight: bold;
  color: #2c3e50;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-card.urgent .stat-number {
  color: white;
}

.stat-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.stat-card.urgent .stat-label {
  color: rgba(255, 255, 255, 0.9);
}

.start-actions {
  margin-bottom: 50px;
}

.start-button {
  padding: 18px 50px;
  font-size: 20px;
  border-radius: 30px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  font-weight: 600;
}

.start-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}


.phase-header {
  position: relative;
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-radius: 8px;
}

.phase-header .close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-size: 20px;
  padding: 0;
}

.phase-header .close-btn:hover {
  color: rgba(255, 255, 255, 0.8);
}

.phase-header h2 {
  margin: 0 0 10px 0;
  font-size: 24px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 15px;
}

.progress-fill {
  height: 100%;
  background: white;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.word-display {
  text-align: center;
  margin-bottom: 30px;
}

.word-card {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* 单词内容布局 */
.word-content {
  display: flex;
  align-items: center;
  gap: 80px;
  max-width: 600px;
  margin: 0 auto;
}

/* 单词图片样式 */
.word-image {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 单词文本样式 */
.word-text {
  flex: 1;
  text-align: left;
  min-width: 0;
}

.word-img {
  max-width: 200px;
  max-height: 150px;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.english-word {
  font-size: 48px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0 0 20px 0;
  text-align: left;
}

.phonetic-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.phonetic {
  font-size: 16px;
  color: #666;
}

.meaning-area, .question-area {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
}

.question-mark {
  font-size: 72px;
  color: #ccc;
  margin-bottom: 20px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meaning-card {
  text-align: center;
  width: 100%;
}

.meaning-card h3 {
  font-size: 32px;
  color: #2c3e50;
  margin: 0 0 15px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.example {
  font-size: 16px;
  color: #666;
  font-style: italic;
  margin: 0;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.delay-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #409EFF;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 20px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 20px;
  border: 1px solid rgba(64, 158, 255, 0.3);
}

.action-buttons .el-button {
  min-width: 120px;
}

.test-mode-selection {
  text-align: center;
  padding: 40px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mode-buttons {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 60px;
  flex-wrap: wrap;
}

.mode-buttons .el-button {
  min-width: 180px;
  height: 60px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.mode-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.spelling-interface {
  text-align: center;
}

.word-info {
  margin-bottom: 30px;
}

.word-info h3 {
  font-size: 28px;
  color: #2c3e50;
  margin: 0 0 15px 0;
}

.input-area {
  margin-bottom: 30px;
}

.timer-display {
  margin-bottom: 15px;
}

.timer-text {
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 8px;
}

.timer-bar {
  width: 100%;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.timer-fill {
  height: 100%;
  background: linear-gradient(90deg, #f56c6c, #ff8e8e);
  border-radius: 3px;
  transition: width 1s linear;
}

.spelling-input {
  width: 300px;
  padding: 15px 20px;
  font-size: 18px;
  border: 2px solid #ddd;
  border-radius: 8px;
  text-align: center;
  margin-right: 15px;
}

.spelling-input:focus {
  outline: none;
  border-color: #409eff;
}

.spelling-input.correct {
  border-color: #67c23a;
  background: #f0f9ff;
}

.spelling-input.incorrect {
  border-color: #f56c6c;
  background: #fef0f0;
}

.answer-display {
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.answer-display.correct {
  background: #f0f9ff;
  border: 2px solid #67c23a;
}

.answer-display.incorrect {
  background: #fef0f0;
  border: 2px solid #f56c6c;
}

.correct-word {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.forced-spelling-interface {
  text-align: center;
}

.forced-spelling-input {
  width: 400px;
  padding: 15px 20px;
  font-size: 18px;
  border: 2px solid #f56c6c;
  border-radius: 8px;
  text-align: center;
  font-family: 'Courier New', monospace;
  letter-spacing: 2px;
}

.expected-char {
  margin-top: 15px;
  font-size: 18px;
  color: #f56c6c;
  font-weight: bold;
}

.summary-content {
  padding: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.stat-label {
  font-weight: 500;
  color: #666;
}

.stat-value {
  font-weight: bold;
  font-size: 18px;
  color: #2c3e50;
}

.stat-value.error {
  color: #f56c6c;
}

.stat-value.success {
  color: #67c23a;
}

.stat-value.coins {
  color: #e6a23c;
  font-weight: bold;
}

.reward-section {
  text-align: center;
  margin: 30px 0;
  padding: 20px;
  background: linear-gradient(135deg, #ffd700, #ffed4e);
  border-radius: 12px;
}

.reward-text {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
}


@media (max-width: 768px) {
  .forced-review-dialog .el-dialog {
    width: 95% !important;
    margin: 10px auto !important;
  }
  
  .start-content {
    padding: 30px 20px;
  }
  
  .word-stats {
    flex-direction: column;
    gap: 20px;
  }
  
  .stat-card {
    min-width: auto;
    padding: 20px 25px;
  }
  
  .review-category h3 {
    font-size: 26px;
  }
  
  .stat-number {
    font-size: 32px;
  }
  
  .start-button {
    padding: 15px 40px;
    font-size: 18px;
  }
  
  .english-word {
    font-size: 32px;
  }
  
  .spelling-input {
    width: 250px;
  }
  
  .forced-spelling-input {
    width: 300px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .action-buttons .el-button {
    width: 200px;
  }
}

/* 平板适配：600px - 1024px */
@media (min-width: 600px) and (max-width: 1024px) {
  .forced-review-dialog .el-dialog {
    width: 90% !important;
    max-width: 760px !important;
    height: auto !important;
    max-height: 90vh !important;
  }

  .forced-review-dialog .el-dialog__body {
    height: auto !important;
    max-height: 70vh !important;
  }

  /* 平板横屏：两栏布局，图片和文本并排 */
  @media (orientation: landscape) {
    .word-content {
      flex-direction: row;
      gap: 40px;
      max-width: 720px;
    }
    .word-img {
      max-width: 240px;
      max-height: 180px;
    }
    .english-word {
      font-size: 40px;
    }
  }

  /* 平板竖屏：垂直堆叠，图标居上，文字与操作按钮在下 */
  @media (orientation: portrait) {
    .word-content {
      flex-direction: column;
      gap: 20px;
      align-items: center;
      text-align: center;
    }
    .word-text {
      text-align: center;
    }
    .word-img {
      max-width: 220px;
      max-height: 160px;
      margin-bottom: 8px;
    }
    .english-word {
      font-size: 36px;
    }
    .action-buttons {
      flex-direction: column;
      gap: 12px;
    }
    .action-buttons .el-button {
      width: 100%;
      max-width: 320px;
    }
  }
}
</style>

<!-- 非 scoped 样式：作用于被挂载到 body 的 el-dialog 元素 -->
<style>
/* Element UI 的 el-dialog 默认会 append 到 body，scoped 样式无法穿透。
   在此使用全局样式确保限制最大宽度 */
.forced-review-dialog .el-dialog,
.forced-review-dialog__wrapper,
.forced-review-dialog .el-dialog__wrapper {
  max-width: 800px !important;
  width: 80% !important; /* 与模板 width="80%" 保持一致 */
}
</style>